module.exports = __webpack_public_path__ + "static/media/window-restore.22d94a41.svg";